import { render, staticRenderFns } from "./crear-editar.vue?vue&type=template&id=21c843a1&scoped=true"
import script from "./crear-editar.vue?vue&type=script&lang=js"
export * from "./crear-editar.vue?vue&type=script&lang=js"
import style0 from "./crear-editar.vue?vue&type=style&index=0&id=21c843a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c843a1",
  null
  
)

export default component.exports